import { api } from '../core';

interface UpdateTimelineEntryDateResponse {
  success: boolean;
}

interface UpdateTimelineEntryDateProps {
  abortController?: AbortController;
  entryId: string;
  date: string;
}

const timelineEntryDateUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateTimelineEntryDate: builder.query<UpdateTimelineEntryDateResponse, UpdateTimelineEntryDateProps>({
      query: ({ abortController = new AbortController(), entryId, date }: UpdateTimelineEntryDateProps) => ({
        url: 'timeline/entry/date/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          date
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateTimelineEntryDate in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateTimelineEntryDateQuery } = timelineEntryDateUpdateApi;
